import { EmptyState } from './EmptyState'
import './styles.scss'
import { useMemo } from 'react'
import Typography from '../../../components/Typography/Typography'
import { TYPOGRAPHY_WEIGHT } from '../../../components/Typography'
import { currencyFormatter } from '../../ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import { TExpectedSavingsByCategoryWidget } from './types'
import { Button, BUTTON_TYPES } from '../../../components/Button'
import { ExpectedSavingsByCategoryPopup } from './ExpectedSavingsByCategoryPopup'
import { useDashboardPopup } from '../Providers/DashboardPopupProvider'

type ExpectedSavingsByCategoryWidgetProps = {
  data: TExpectedSavingsByCategoryWidget
}

export const ExpectedSavingsByCategoryWidget = ({
  data
}: ExpectedSavingsByCategoryWidgetProps) => {
  const seeMoreButtonVisible = useMemo(
    () => Object.keys(data).length > 6,
    [data]
  )

  const {
    expectedSavingsByCategoryPopup: {
      actions: { open }
    }
  } = useDashboardPopup()

  return (
    <div className="expected-savings-block additional-values-block half-width charts_ongoing-contracts_container">
      <div className="row space-between align-center additional-values-block__header">
        <div className="charts_title">Expected savings by category</div>
      </div>

      {data?.length ? (
        <div className="mt-8">
          {data.map(([key, value], index) => {
            return (index < 5 && seeMoreButtonVisible) ||
              !seeMoreButtonVisible ? (
              <div className="row space-between align-center full-width additional-values-row">
                <Typography.Body2 className="additional-values-row__title">
                  {key}
                </Typography.Body2>
                <Typography.Body2 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
                  ${currencyFormatter(value)}
                </Typography.Body2>
              </div>
            ) : null
          })}
          {seeMoreButtonVisible && (
            <Button
              type={BUTTON_TYPES.LINK}
              onClick={open}
              className="show-more-button"
            >
              See other categories
            </Button>
          )}
        </div>
      ) : (
        <EmptyState />
      )}
      <ExpectedSavingsByCategoryPopup data={data} />
    </div>
  )
}
